import { Injectable } from '@angular/core';
import { Logger } from 'projects/common/src/app/classes';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { MiningToastService as ToastService } from 'projects/common/src/app/services';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DomErrorInterceptorService extends Logger implements HttpInterceptor {

  constructor(
    private toastrService: ToastService
  ) {
    super();
  }

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: any) => {
        if (err instanceof DOMException) {
          this.toastrService.error(err.name, err.message);
          this.error(err.message);
        }
        return throwError(err);
      }
    ));
  }
}
